import Map from "ol/Map";
import MousePosition from "ol/control/MousePosition";
import View from "ol/View";
import Tile from "ol/layer/Tile";
import Vector from "ol/layer/Vector";
import TileWMS from "ol/source/TileWMS";
import Graticule from "ol/Graticule";
import Stroke from "ol/style/Stroke";
import { Extent } from "ol/extent";
import SourceVector from "ol/source/Vector";
import { defaults as controlDefaults } from "ol/control";
import { DragBox } from "ol/interaction";
import { Options as dragBoxOptions } from "ol/interaction/DragBox";
import { platformModifierKeyOnly } from "ol/events/condition";
import Polygon, { fromExtent } from "ol/geom/Polygon";
import Feature from "ol/Feature";
import SubsettingParameters from "./subsetting-parameters";
import { DownloadFormat } from "./download-formats";
import BoundingBox from "./bounding-box";
import MapData from "./map-data";

import proj4 from "proj4";
import { register } from "ol/proj/proj4";
import { get as getProjection, ProjectionLike } from "ol/proj";
import Overlay from "ol/Overlay";
import OverlayPositioning from "ol/OverlayPositioning";
import { getGraticuleSourceVectorLayer } from "./graticules";

proj4.defs(
  "EPSG:9354",
  "+proj=stere +lat_0=-90 +lat_ts=-65 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs"
);
proj4.defs(
  "EPSG:3996",
  "+proj=stere +lat_0=90 +lat_ts=75 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs"
);
register(proj4);

let subsettingClasses: any = {
  "EPSG:4326": new SubsettingParameters(
    new BoundingBox(-180, 360, 90, -90),
    "EPSG:4326",
    null,
    "West",
    "South",
    "East",
    "North",
    240,
    4
  ),
  "EPSG:9354": new SubsettingParameters(
    new BoundingBox(-4800000, 4800000, 4800000, -4800000),
    "EPSG:9354",
    getGraticuleSourceVectorLayer(
      -90,
      -50,
      [-80, -70, -60, -50],
      "EPSG:4326",
      "EPSG:9354"
    ),
    "Min x",
    "Min y",
    "Max x",
    "Max y",
    1 / 500,
    0
  ),
  "EPSG:3996": new SubsettingParameters(
    new BoundingBox(-2910000, 2910000, 2910000, -2910000),
    "EPSG:3996",
    getGraticuleSourceVectorLayer(
      90,
      60,
      [80, 70, 60],
      "EPSG:4326",
      "EPSG:3996"
    ),
    "Min x",
    "Min y",
    "Max x",
    "Max y",
    1 / 200,
    0
  ),
};

$(document).ready(function () {
  let gridKey = $("#sidebar-grid-select").find(".dropdown-item").val();
  selectedGridOption = gridKey.toString();
  updateGridHelpText();
  $.ajax({
    url: "/api/settings/map/" + gridKey,
    success: function (data) {
      let mainData = new MapData(
        data.main.url,
        data.main.layers,
        data.main.format
      );
      let sidData = new MapData(data.sid.url, data.sid.layers, data.sid.format);
      let customZoom = data.zoom;
      let projection = data.projection;
      subsetSettings = subsettingClasses[projection];
      createMap(mainData, sidData, projection, customZoom);
      enableMouseRegionSelection();
      updateSidebar();
      addEventHandlers();
    },
  });
});

var downloadProgressPercentage = 0;
var canDownload = false;
var errorTimeoutHandle: number;
var map: Map;
var coordinateDisplayControl: MousePosition;
var mainGridLayer: Tile;
var sidGridLayer: Tile;
var selectionLayer: Vector;
var graticuleControl: Graticule;
var graticuleLayer: Vector;
var graticuleVisible: boolean;
var subsetSettings: SubsettingParameters;
var maxZoom = 20;
var minZoom = 1;
var selectedGridOption: string;

var $sidebarCoordinateInputs = $("#coordinates-card input");
var $sidebarCoordinateInputsClearLink = $(
  "#coordinates-card #sidebar-clear-coordinates"
);
var $sidebarFormatCheckboxes = $("#formats-card input.form-check-input");
var $sidebarDataSelectionBounds = $("#data-selection-region");
var $sidebarDataSelectionGridVersion = $("#data-selection-grid-version");
var $sidebarDataFormats = $("#data-selection-formats");
var $sidebarGridDimensions = $("#data-selection-grid-dimensions");
var $sidebarDataFileSize = $("#data-selection-size");
var $sidebarAddToBasketButton = $("#sidebar-add-to-basket");

function addEventHandlers() {
  $sidebarCoordinateInputsClearLink.click(function (event) {
    event.preventDefault();
    clearCoordinates();
  });

  $sidebarFormatCheckboxes.change(function () {
    var sender = $(this);
    var format = sender.attr("data-format");
    var formatIndex = format as keyof typeof DownloadFormat;

    if (sender.is(":checked")) {
      subsetSettings.addFormat(DownloadFormat[formatIndex]);
    } else {
      subsetSettings.removeFormat(DownloadFormat[formatIndex]);
    }

    updateSidebar();
  });

  $sidebarCoordinateInputs.change(function () {
    var input = $(this);
    var bounds = input.attr("data-bounds");

    var valueAsString = input.val();
    var value: number = Number(valueAsString);

    var west = subsetSettings.left;
    var south = subsetSettings.bottom;
    var east = subsetSettings.right;
    var north = subsetSettings.top;

    if (!isNaN(value)) {
      switch (bounds) {
        case "west":
          west = value;
          break;

        case "south":
          south = value;
          break;

        case "east":
          east = value;
          break;

        case "north":
          north = value;
          break;
      }
    }

    subsetSettings.setAndClipRectangle(west, south, east, north);
    updateMapRegion(subsetSettings);
    updateSidebar();
  });

  $sidebarAddToBasketButton.click(addToBasket);

  $(".sidebar-grid-select-option").on("click", function () {
    let gridKey = $(this).val();
    selectedGridOption = gridKey.toString();
    updateGridHelpText();
    $.ajax({
      url: "/api/settings/map/" + gridKey,
      success: function (data) {
        let mainData = new MapData(
          data.main.url,
          data.main.layers,
          data.main.format
        );
        let sidData = new MapData(
          data.sid.url,
          data.sid.layers,
          data.sid.format
        );
        if (subsetSettings.projection !== data.projection) {
          clearCoordinates();
        }
        let customZoom = data.zoom;
        subsetSettings = subsettingClasses[data.projection];
        subsetSettings.projection = data.projection;
        updateMapLayers(
          mainData,
          sidData,
          subsetSettings.projection,
          customZoom
        );
        updateSidebar();
      },
    });
  });

  $("body").on("click", "#basket-download-button", downloadBasket);
  $("body").on(
    "click",
    "#basket-download-with-email-button",
    emailDownloadLink
  );
  $("body").on("click", "#basket-empty-button", emptyBasket);
  $("body").on("show.bs.modal", "#basketModal", populateBasket);
  $("body").on("hide.bs.modal", "#basketModal", closeBasket);
  $("body").on("click", ".basket-delete-item", deleteItem);
  $("body").on("click", "#zoom-in-button", zoomIn);
  $("body").on("click", "#zoom-out-button", zoomOut);
  $("body").on("click", "#show-sid-grid", showSidGrid);
  $("body").on("click", "#show-graticule", showGraticule);
}

function updateGridHelpText() {
  let $selectedOption = $(
    `.sidebar-grid-select-option[value="${selectedGridOption}"]`
  );
  $("#sidebar-grid-select")
    .find(".dropdown-toggle")
    .text($selectedOption.text());
  let helpText = $selectedOption.data("help-text");
  if (
    selectedGridOption === "SOUTH_POLE" ||
    selectedGridOption === "SOUTH_POLE_SUB_ICE" ||
    selectedGridOption === "NORTH_POLE"
  ) {
    $("#boundaries_help").css("visibility", "visible");
  } else {
    $("#boundaries_help").css("visibility", "hidden");
  }
  if (!!helpText) {
    var $modal = $("#grid-help-modal");
    $modal.find(".modal-title").html($selectedOption.text());
    $modal.find(".modal-body-text").html(helpText);
    $("#grid-help-link").css("visibility", "visible");
  } else {
    $("#grid-help-link").css("visibility", "hidden");
  }
  let $shadedReliefOptions = $("#shaded-relief-row");
  $shadedReliefOptions.hide();
  $.ajax({
    url: "/api/settings/has_hillshade_file/" + selectedGridOption,
    success: function (data) {
      if (data) {
        $shadedReliefOptions.show();
      } else {
        $shadedReliefOptions.hide();
      }
    },
  });
}

function showGraticule() {
  var $button = $("#show-graticule");
  $button.removeClass("active");
  if (graticuleVisible) {
    if (subsetSettings.graticuleLayer == null) {
      graticuleControl.setMap(null);
    } else {
      subsetSettings.graticuleLayer.setVisible(false);
    }
  } else {
    if (subsetSettings.graticuleLayer == null) {
      graticuleControl.setMap(map);
    } else {
      subsetSettings.graticuleLayer.setVisible(true);
    }
    $button.addClass("active");
  }

  graticuleVisible = !graticuleVisible;
}

function showSidGrid() {
  var visible = !sidGridLayer.getVisible();
  sidGridLayer.setVisible(visible);
  var $button = $("#show-sid-grid");
  $button.removeClass("active");
  if (visible) {
    $button.addClass("active")
  }
}

function zoomIn() {
  var current = map.getView().getZoom();
  var newZoom = current + 1;
  newZoom = newZoom > maxZoom ? maxZoom : newZoom;
  map.getView().setZoom(newZoom);
}

function zoomOut() {
  var current = map.getView().getZoom();
  var newZoom = current - 1;
  newZoom = newZoom < minZoom ? minZoom : newZoom;
  map.getView().setZoom(newZoom);
}

function getCoordinateDisplayControl(
  projection: ProjectionLike
): MousePosition {
  var mousePosition = new MousePosition({
    coordinateFormat: function (coordinate) {
      var x: string;
      var y: string;

      switch (subsetSettings.projection) {
        case "EPSG:4326": {
          var span = Math.floor((coordinate[0] + 180.0) / 360.0);
          var correctedLongitude = coordinate[0] - span * 360.0;
          x = getCoordinateDisplayValue(correctedLongitude, -180, 180, 3, 8);
          y = getCoordinateDisplayValue(coordinate[1], -90, 90, 3, 7);
          break;
        }
        case "EPSG:9354": {
          let box = subsetSettings.boundingBox;
          x = getCoordinateDisplayValue(
            coordinate[0],
            box.left,
            box.right,
            0,
            7
          );
          y = getCoordinateDisplayValue(
            coordinate[1],
            box.bottom,
            box.top,
            0,
            7
          );
          break;
        }
        case "EPSG:3996": {
          let box = subsetSettings.boundingBox;
          x = getCoordinateDisplayValue(
            coordinate[0],
            box.left,
            box.right,
            0,
            7
          );
          y = getCoordinateDisplayValue(
            coordinate[1],
            box.bottom,
            box.top,
            0,
            7
          );
          break;
        }
      }
      return `${x}, ${y}`;
    },

    className: "coordinate-display",
    target: document.getElementById("coordinate-display"),
    undefinedHTML: "&nbsp;".repeat(5) + "---," + "&nbsp;".repeat(5) + "---",
    projection: projection,
  });
  return mousePosition;
}

function getCoordinateDisplayValue(
  input: number,
  min: number,
  max: number,
  fractionDigits: number,
  length: number
) {
  var output = "";

  if (input < min || input > max) {
    output = "---";
  } else {
    output = input.toLocaleString("en-US", {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    });
  }

  var extraSpaces = length - output.length;

  if (extraSpaces > 0) {
    output = "&nbsp;".repeat(extraSpaces) + output;
  }

  return output;
}

function getGraticuleControl() {
  var graticule = new Graticule({
    strokeStyle: new Stroke({
      color: "rgba(255,120,0,0.9)",
      width: 1,
    }),
    showLabels: true,
  });

  return graticule;
}

function getLayers(mainMapData: MapData, sidMapData: MapData) {
  mainGridLayer = new Tile({
    source: new TileWMS({
      url: mainMapData.url,
      params: {
        LAYERS: mainMapData.layers,
        FORMAT: mainMapData.format,
      },
      transition: 0,
      wrapX: true,
    }),
  });

  sidGridLayer = new Tile({
    source: new TileWMS({
      url: sidMapData.url,
      params: {
        LAYERS: sidMapData.layers,
        FORMAT: sidMapData.format,
      },
      transition: 0,
      wrapX: true,
    }),
  });

  selectionLayer = new Vector({
    source: vectorSource,
    updateWhileAnimating: true,
    updateWhileInteracting: true,
    renderMode: "vector",
  });

  var layers = [mainGridLayer, sidGridLayer, selectionLayer];

  if (subsetSettings.graticuleLayer != null) {
    layers.push(subsetSettings.graticuleLayer);
    subsetSettings.graticuleLayer.setVisible(false);
  }

  graticuleVisible = false;
  graticuleControl.setMap(null);
  return layers;
}

var vectorSource = new SourceVector();

function createMap(
  mainMapData: MapData,
  sidMapData: MapData,
  projection: ProjectionLike,
  customZoom: number = 3
) {
  graticuleControl = getGraticuleControl();
  var layers = getLayers(mainMapData, sidMapData);
  coordinateDisplayControl = getCoordinateDisplayControl(projection);

  map = new Map({
    controls: controlDefaults({
      zoom: false,
    }).extend([coordinateDisplayControl]),
    layers: layers,
    target: "map",
    view: new View({
      projection: getProjection(projection),
      center: [0, 0],
      zoom: customZoom,
    }),
  });

  sidGridLayer.setVisible(false);
}

function updateMapLayers(
  mainMapData: MapData,
  sidMapData: MapData,
  projection: ProjectionLike,
  customZoom: number = 3
) {
  var layers = getLayers(mainMapData, sidMapData);

  // remove old layers
  const oldLayers = [...map.getLayers().getArray()];
  oldLayers.forEach((layer) => map.removeLayer(layer));

  map.setView(
    new View({
      projection: getProjection(projection),
      center: [0, 0],
      zoom: customZoom,
    })
  );

  // add new layers
  for (let newLayer of layers) {
    map.addLayer(newLayer);
  }

  coordinateDisplayControl.setProjection(projection);
  sidGridLayer.setVisible(false);
}

function enableMouseRegionSelection() {
  var dragBox = new DragBox(<dragBoxOptions>{
    condition: platformModifierKeyOnly,
  });

  map.addInteraction(dragBox);

  dragBox.on("boxstart", function () {
    (<any>$("#mouse-instruction-alert")).alert("close");
    (<any>$(".alert-active")).alert("close");
    vectorSource.clear();
    subsetSettings.clearRectangle();
    updateSidebar();
  });

  dragBox.on("boxend", function () {
    // ol.Extent is an array of number in the order:
    //    [min_x, min_y, max_x, max_y] corresponding to
    //    [west,  south, east,  north]
    var extent: Extent = dragBox.getGeometry().getExtent();

    switch (subsetSettings.projection) {
      case "EPSG:4326": {
        var westMostLongitude = extent[0];
        var southMostLatitude = extent[1];
        var eastMostLongitude = extent[2];
        var northMostLatitiude = extent[3];
        // The longitude must be within the range -180 to +180.
        var span = Math.floor((westMostLongitude + 180.0) / 360.0);
        var correction = span * 360.0;
        westMostLongitude -= correction;
        eastMostLongitude -= correction;
        subsetSettings.setAndClipRectangle(
          westMostLongitude,
          southMostLatitude,
          eastMostLongitude,
          northMostLatitiude
        );
        break;
      }

      case "EPSG:9354": {
        subsetSettings.setAndClipRectangle(
          extent[0],
          extent[1],
          extent[2],
          extent[3]
        );
        break;
      }
      case "EPSG:3996": {
        subsetSettings.setAndClipRectangle(
          extent[0],
          extent[1],
          extent[2],
          extent[3]
        );
        break;
      }
    }

    updateMapRegion(subsetSettings);
    updateSidebar();
  });
}

function formatLatitude(latitude: number) {
  /* For latitude, if the value is negative include 'S' after the number and don't include '-' before the number,
    if it is positive include 'N' after the number*/
  if (Math.sign(latitude) === -1) {
    return Math.abs(latitude) + "S";
  }
  return latitude + "N";
}

function formatLongitude(longitude: number) {
  /* For longitude if the value is negative add 'W' after the number 
    and don't include '-' before the number; if it is positive add 'E' after the number. */
  if (Math.sign(longitude) === -1) {
    return Math.abs(longitude) + "W";
  }
  return longitude + "E";
}

function displayPolarLatLon(
  pixel: any,
  tooltipName: string,
  fromProj: any,
  toProj: any
) {
  var asLonLat = proj4(fromProj, toProj, pixel); //[x=longitude,y=latitude]
  let sidepanelCtrl = document.getElementById("sidepanel-" + tooltipName);
  let lat = Math.round(asLonLat[1] * 100) / 100;
  let lon = Math.round(asLonLat[0] * 100) / 100;
  sidepanelCtrl.setAttribute(
    "value",
    formatLatitude(lat) + " " + formatLongitude(lon)
  );
  if (
    subsetSettings.left === 0 &&
    subsetSettings.right === 0 &&
    subsetSettings.bottom === 0 &&
    subsetSettings.top === 0
  ) {
    return;
  }
  var tooltip = document.createElement("div");
  tooltip.setAttribute("id", "box-" + tooltipName);
  tooltip.setAttribute("class", "tooltip");
  var overlay = new Overlay({
    element: tooltip,
    offset: [0, 0],
    positioning: OverlayPositioning.BOTTOM_LEFT,
  });
  map.addOverlay(overlay);
  overlay.setPosition(pixel);
  overlay.getElement().innerHTML =
    formatLatitude(lat) + " " + formatLongitude(lon);
}

function updateMapRegion(settings: SubsettingParameters) {
  vectorSource.clear();

  if (settings.coordinatesAreValid) {
    var possiblyClippedRegion: Polygon;
    possiblyClippedRegion = fromExtent([
      settings.left,
      settings.bottom,
      settings.right,
      settings.top,
    ]);

    var box = new Feature({
      name: "region",
      geometry: possiblyClippedRegion,
    });

    vectorSource.addFeature(box);
  }
}

function clearCoordinates() {
  map.getOverlays().clear();
  subsetSettings.clearRectangle();
  vectorSource.clear();
  updateSidebar();
}

function getFormattedCoordinate(coordinate: number, decimalPlaces: number) {
  return coordinate.toLocaleString("en-US", {
    maximumFractionDigits: decimalPlaces,
  });
}

function updateSidebar() {
  let dp = subsetSettings.displayDecimalPlaces;

  // Coordinates

  $sidebarCoordinateInputs.each(function () {
    var box = $(this);
    var bounds = box.attr("data-bounds");

    switch (bounds) {
      case "west":
        box.val(getFormattedCoordinate(subsetSettings.left, dp));
        break;

      case "south":
        box.val(getFormattedCoordinate(subsetSettings.bottom, dp));
        break;

      case "east":
        box.val(getFormattedCoordinate(subsetSettings.right, dp));
        break;

      case "north":
        box.val(getFormattedCoordinate(subsetSettings.top, dp));
        break;
    }
    if (subsetSettings.projection !== "EPSG:9354" && subsetSettings.projection !== "EPSG:3996") {
      document.getElementById("sidepanel-top-right").style.display = "none";
      document.getElementById("sidepanel-bottom-left").style.display = "none";
    }
    if (subsetSettings.projection === "EPSG:9354" || subsetSettings.projection === "EPSG:3996") {
      document.getElementById("sidepanel-top-right").style.display = "block";
      document.getElementById("sidepanel-bottom-left").style.display = "block";
      var fromProj = proj4.defs(subsetSettings.projection);
      var toProj = proj4.defs("EPSG:4326");
      map.getOverlays().clear();
      displayPolarLatLon(
        [subsetSettings.left, subsetSettings.bottom],
        "bottom-left",
        fromProj,
        toProj
      );
      displayPolarLatLon(
        [subsetSettings.right, subsetSettings.top],
        "top-right",
        fromProj,
        toProj
      );
    }
  });

  // Formats

  $sidebarFormatCheckboxes.each(function () {
    var format = $(this).attr("data-format");
    var formatIndex = format as keyof typeof DownloadFormat;
    $(this).prop(
      "checked",
      subsetSettings.hasFormat(DownloadFormat[formatIndex]) ? "checked" : ""
    );
  });

  // Data selection box

  // Bounds

  let top = subsetSettings.topName;
  let left = subsetSettings.leftName;
  let bottom = subsetSettings.bottomName;
  let right = subsetSettings.rightName;

  let sideBarDataSelectionHtml =
    '<table class="table table-sm">' +
    "<thead>" +
    "<tr>" +
    `<th scope="col">${left}</th>` +
    `<th scope="col">${right}</th>` +
    `<th scope="col">${bottom}</th>` +
    `<th scope="col">${top}</th>` +
    "</tr>" +
    "</thead>" +
    "<tbody>" +
    "<tr>" +
    `<td>${getFormattedCoordinate(subsetSettings.left, dp)}</td>` +
    `<td>${getFormattedCoordinate(subsetSettings.right, dp)}</td>` +
    `<td>${getFormattedCoordinate(subsetSettings.bottom, dp)}</td>` +
    `<td>${getFormattedCoordinate(subsetSettings.top, dp)}</td>` +
    "</tr>" +
    "</tbody>" +
    "</table>";

  $sidebarDataSelectionBounds.html(sideBarDataSelectionHtml);

  // Grid dimensions

  $sidebarGridDimensions.html(
    `<strong>W</strong> ${subsetSettings.estimatedGridWidth()} ` +
      `<strong>H</strong> ${subsetSettings.estimatedGridHeight()}`
  );

  // File formats

  let gridFormats: string = "";
  let sidFormats: string = "";

  let gridFormatsCount: number = 0;
  let sidFormatsCount: number = 0;

  for (let f of subsetSettings.formats.sort((a, b) => a - b)) {
    switch (f) {
      case DownloadFormat.gridNetCdf:
        gridFormats += gridFormatsCount > 0 ? ", netCDF" : "netCDF";
        gridFormatsCount++;
        break;

      case DownloadFormat.gridGeoTiff:
        gridFormats += gridFormatsCount > 0 ? ", GeoTIFF" : "GeoTIFF";
        gridFormatsCount++;
        break;

      case DownloadFormat.gridEsriAscii:
        gridFormats += gridFormatsCount > 0 ? ", Esri ASCII" : "Esri ASCII";
        gridFormatsCount++;
        break;

      case DownloadFormat.sidNetCdf:
        sidFormats += sidFormatsCount > 0 ? ", netCDF" : "netCDF";
        sidFormatsCount++;
        break;

      case DownloadFormat.sidGeoTiff:
        sidFormats += sidFormatsCount > 0 ? ", INT16 GeoTIFF" : "INT16 GeoTIFF";
        sidFormatsCount++;
        break;

      case DownloadFormat.sidEsriAscii:
        sidFormats += sidFormatsCount > 0 ? ", Esri ASCII" : "Esri ASCII";
        sidFormatsCount++;
        break;

      case DownloadFormat.colorJpeg:
        gridFormats +=
          sidFormatsCount > 0 ? ", Colour Map JPEG" : " Colour Map JPEG";
        gridFormatsCount++;
        break;

      case DownloadFormat.colorPng:
        gridFormats +=
          sidFormatsCount > 0 ? ", Colour Map PNG" : " Colour Map PNG";
        gridFormatsCount++;
        break;

      case DownloadFormat.shadedReliefJpeg:
        gridFormats +=
          sidFormatsCount > 0 ? ", Shaded Relief JPEG" : " Shaded Relief JPEG";
        gridFormatsCount++;
        break;

      case DownloadFormat.shadedReliefPng:
        gridFormats +=
          sidFormatsCount > 0 ? ", Shaded Relief PNG" : " Shaded Relief PNG";
        gridFormatsCount++;
        break;
    }
  }

  if (gridFormats.length == 0) {
    gridFormats = "none";
  }

  if (sidFormats.length == 0) {
    sidFormats = "none";
  }

  $sidebarDataSelectionGridVersion.html(
    $(`.sidebar-grid-select-option[value="${selectedGridOption}"]`).text()
  );

  $sidebarDataFormats.html(
    `<strong>Grid</strong>: ${gridFormats}<br /><strong>TID grid</strong>: ${sidFormats}`
  );

  // File size

  $sidebarDataFileSize.html(
    subsetSettings.estimatedFileSizeMB().toString() + " MB"
  );
}

function addToBasket() {
  var basketId = $("#basket-id").val();
  var gridKey = selectedGridOption;

  $.ajax({
    url: "/api/basket/" + basketId + "/items",
    method: "POST",
    data: JSON.stringify({
      top: subsetSettings.top,
      bottom: subsetSettings.bottom,
      left: subsetSettings.left,
      right: subsetSettings.right,
      projection: subsetSettings.projection,
      netcdf_elevation: subsetSettings.hasFormat(DownloadFormat.gridNetCdf),
      geotiff_elevation: subsetSettings.hasFormat(DownloadFormat.gridGeoTiff),
      esri_ascii_elevation: subsetSettings.hasFormat(
        DownloadFormat.gridEsriAscii
      ),
      netcdf_sid: subsetSettings.hasFormat(DownloadFormat.sidNetCdf),
      geotiff_sid: subsetSettings.hasFormat(DownloadFormat.sidGeoTiff),
      esri_ascii_sid: subsetSettings.hasFormat(DownloadFormat.sidEsriAscii),
      color_jpeg: subsetSettings.hasFormat(DownloadFormat.colorJpeg),
      color_png: subsetSettings.hasFormat(DownloadFormat.colorPng),
      shaded_relief_jpeg: subsetSettings.hasFormat(
        DownloadFormat.shadedReliefJpeg
      ),
      shaded_relief_png: subsetSettings.hasFormat(
        DownloadFormat.shadedReliefPng
      ),
      grid_key: gridKey,
    }),
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    timeout: 5000,
    success: function (data) {
      updateBasketBadge(data.item_count);
      // For UI indication of success, rely on the basket badge being updated.
      // Have left the displayInfoAlert call below in, but it seems
      // it isn't required.
      // displayInfoAlert(
      //     "The subset has been added to the basket",
      //     "Click the 'View basket' button to see all the items you've added."
      // );
    },
    error: function (data) {
      if (data.status === 400) {
        displayErrorAlert(
          "There was a problem adding your item to the basket",
          data.responseJSON.clientMessage
        );
      }
    },
  });
}

function displayInfoAlert(title: string, message: string) {
  displayAlert("alert-info", title, message);
}

function displayErrorAlert(title: string, message: string) {
  (<any>$(".alert-active")).alert("close");
  displayAlert("alert-danger", title, message);

  if (errorTimeoutHandle != -1) {
    clearTimeout(errorTimeoutHandle);
  }

  errorTimeoutHandle = window.setTimeout(function () {
    (<any>$(".alert-active")).alert("close");
  }, 5000);
}

function displayAlert(cssClass: string, title: string, message: string) {
  var alertClone = $(".alerts .alert-template." + cssClass).clone();
  alertClone.children().filter(".alert-heading").html(title);
  alertClone.children().filter("p").html(message);
  alertClone.removeClass("alert-template");
  alertClone.addClass("alert-active");

  $(".alerts-row-span").prepend(alertClone);
}

function updateBasketBadge(count: number) {
  var html = count == 0 ? "" : count.toString();
  $("#sidebar-basket-count-badge").html(html);
}

function populateBasket() {
  var basketId = $("#basket-id").val();
  canDownload = true;

  $("#basket-download-button").show();
  $("#basket-download-with-email-button").hide();
  $("#basket-download-more-information").hide();
  $("#basket-download-progress-container").hide();

  $.ajax({
    url: "/api/basket/" + basketId,
    method: "GET",
    async: false,
  }).done(function (data) {
    var tableBody = $("table#modal-basket-items tbody");
    var index: number = 0;
    var tableItemsHtml = "";

    if (data.items.length == 0) {
      $("#modal-basket-empty-message").show();
      $("#modal-basket-items").hide();
      $("#basket-empty-button").prop("disabled", true);
      $("#basket-download-button").prop("disabled", true);
    } else {
      $("#modal-basket-empty-message").hide();
      $("#modal-basket-items").show();
      $("#basket-empty-button").prop("disabled", false);
      $("#basket-download-button").prop("disabled", false);

      for (let item of data.items){
        var coordinates = "";
        if(subsetSettings.projection === "EPSG:4326"){
            coordinates = `North: ${getFormattedCoordinate(item.top, 4)}, `;
            coordinates += `South: ${getFormattedCoordinate(item.bottom, 4)}, `;
            coordinates += `West: ${getFormattedCoordinate(item.left, 4)}, `;
            coordinates += `East: ${getFormattedCoordinate(item.right, 4)}`;
        }
        else {                      
            coordinates = `Max Y: ${getFormattedCoordinate(item.top, 4)}, `;
            coordinates += `Min Y: ${getFormattedCoordinate(item.bottom, 4)}, `;
            coordinates += `Min X: ${getFormattedCoordinate(item.left, 4)}, `;
            coordinates += `Max X: ${getFormattedCoordinate(item.right, 4)}`;
        }

        var elevationFormats = "";

        if (item.netcdf_elevation) {
          elevationFormats += "netCDF";
        }

        if (item.geotiff_elevation) {
          if (elevationFormats.length > 0) {
            elevationFormats += ", ";
          }
          elevationFormats += "GeoTIFF";
        }

        if (item.esri_ascii_elevation) {
          if (elevationFormats.length > 0) {
            elevationFormats += ", ";
          }
          elevationFormats += "ESRI ASCII";
        }

        var sidFormats = "";

        if (item.netcdf_sid) {
          sidFormats += "netCDF";
        }

        if (item.geotiff_sid) {
          if (sidFormats.length > 0) {
            sidFormats += ", ";
          }
          sidFormats += "GeoTIFF";
        }

        if (item.esri_ascii_sid) {
          if (sidFormats.length > 0) {
            sidFormats += ", ";
          }
          sidFormats += "ESRI ASCII";
        }

        var imageFormats = [];
        if (item.color_jpeg) {
          imageFormats.push("Color Map JPEG");
        }
        if (item.color_png) {
          imageFormats.push("Color Map PNG");
        }
        if (item.shaded_relief_jpeg) {
          imageFormats.push("Shaded Relief JPEG");
        }
        if (item.shaded_relief_png) {
          imageFormats.push("Shaded Relief PNG");
        }

        var formats = "";

        if (elevationFormats.length > 0) {
          formats += `Grid - ${elevationFormats}`;
        }

        if (sidFormats.length > 0) {
          if (formats.length > 0) {
            formats += "; ";
          }
          formats += `TID grid - ${sidFormats}`;
        }

        if (imageFormats.length > 0) {
          if (formats.length > 0) {
            formats += "; ";
          }
          formats += "Images - " + imageFormats.join(", ");
        }

        var gridVersion = $(
          `.sidebar-grid-select-option[value="${item.grid_key}"]`
        ).text();

        var itemHtml = `<td><strong>Grid:</strong> ${gridVersion}<br/><strong>${coordinates}</strong><br /><strong>Formats:</strong>  ${formats}</td>`;
        var deleteHtml = `<td><a href="#" class="basket-delete-item" data-item-index="${index}"><i class="fas fa-times" data-item-index="${index}"></i> Delete</a></td>`;

        tableItemsHtml += `<tr>${itemHtml}${deleteHtml}</tr>\n`;
        index++;
      }
      tableBody.html(tableItemsHtml);
    }
  });
}

function closeBasket() {
  $(".usually-hidden").hide();
  $("#basket-download-more-information-error-message").html("");
  $(".usually-visible").show();
  canDownload = false;
}

function deleteItem(event: Event) {
  event.preventDefault();
  var item = $(this).attr("data-item-index");

  var basketId = $("#basket-id").val();

  $.ajax({
    url: "/api/basket/" + basketId + "/items/" + item,
    method: "DELETE",
    async: false,
  }).done(function (data) {
    populateBasket();
    updateBasketBadge(data.item_count);
  });
}

function emptyBasket() {
  var basketId = $("#basket-id").val();

  $.ajax({
    url: "/api/basket/" + basketId + "/items",
    method: "DELETE",
    async: false,
  }).done(function (data) {
    populateBasket();
    updateBasketBadge(data.item_count);
  });
}

function downloadBasket() {
  var basketId = $("#basket-id").val();

  $.ajax({
    url: "/api/basket/" + basketId + "/generate",
    method: "POST",
    data: JSON.stringify({
      // Empty
    }),
    contentType: "application/json; charset=utf-8",
    dataType: "json",
  }).done(function (data) {
    let status = data.status;
    let delivery = data.delivery;

    if (status === "submitted") {
      if (delivery === "immediate") {
        $("#basket-download-progress-container").show();
        downloadProgressPercentage = 10;
        $("#basket-download-progress-bar").attr(
          "style",
          "width:" + downloadProgressPercentage + "%;"
        );
        pollDownloadStatus();
      } else if (delivery === "email") {
        emptyBasket();
        getNewBasket();
        closeBasketDialog();
      }
    } else if (status === "deferred") {
      $("#basket-download-button").hide();
      $("#basket-download-with-email-button").show();
      $("#basket-download-more-information").show();
    }
  });
}

function emailDownloadLink() {
  var basketId = $("#basket-id").val();
  var email_address = $("#basket-email-address-input").val();

  $.ajax({
    url: "/api/basket/" + basketId + "/generate",
    data: JSON.stringify({
      email_address: email_address,
    }),
    method: "POST",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
  })
    .done(function () {
      emptyBasket();
      getNewBasket();
      closeBasketDialog();
    })
    .fail(function (data, textStatus, errorThrown) {
      if (data.status === 400) {
        if (data.responseJSON.status === "invalid_email_address") {
          $("#basket-download-more-information-error-message").html(
            data.responseJSON.clientMessage
          );
        }
      }
    });
}

function pollDownloadStatus() {
  if (!canDownload) {
    return;
  }

  var basketId = $("#basket-id").val();

  setTimeout(function () {
    $.ajax({
      url: "/api/basket/" + basketId + "/generate",
      method: "GET",
    }).done(function (data) {
      if (data.status === "ready") {
        console.log("download is ready");
        emptyBasket();
        getNewBasket();
        closeBasketDialog();
        downloadURI("/api/basket/" + basketId + "/download");
      } else {
        downloadProgressPercentage += 5;
        $("#basket-download-progress-bar").attr(
          "style",
          "width:" + downloadProgressPercentage + "%;"
        );
        setTimeout(pollDownloadStatus, 500);
      }
    });
  }, 1000);
}

function closeBasketDialog() {
  $(".usually-hidden").hide();
  $("#basket-download-more-information-error-message").html("");
  $(".usually-visible").show();
  (<any>$("#basketModal")).modal("hide");
}

function getNewBasket() {
  $.ajax({
    url: "/api/basket",
    method: "POST",
    async: false,
  }).done(function (data) {
    let basketId = data.basket_id;
    $("#basket-id").val(basketId);
  });
}

function downloadURI(uri: string) {
  // TODO Handle cross browser issues here.
  window.location.href = uri;
}
